import redux from '@reduxjs/toolkit';
import authReducer, { AuthStateShape } from './auth';
import { StateShape as TemplateEditorStateShape, templateEditorReducer } from './templateEditor';
import { StateShape as AppStateShape, appReducer } from './app';
import { StateShape as AdminPagesStateShape, reducer as AdminPagesReducer } from './pages';
import {
    StateShape as AdminComponentsStateShape,
    componentsReducer as AdminComponentsReducer,
} from './components';
import {
    StateShape as AdminPublicComponentsStateShape,
    publicComponentsReducer as AdminPublicComponentsReducer,
} from './publicComponents';
import { StateShape as AdminThemesStateShape, themesReducer } from './themes';
import { StateShape as AdminQueryStateShape, queryReducer } from './query';
import { StateShape as AdminUsersStateShape, usersReducer } from './users';
import { StateShape as resourcesStateShape, resourcesReducer } from './resources';
import { StateShape as adminUIStateShape, adminUIReducer } from './adminUI';
import { StateShape as listsStateShape, listsReducer } from './lists';
import { StateShape as AdminMediaStateShape, mediaReducer } from './media';
import { StateShape as envDiffStateShape, envDiffReducer } from './envDiff';
import { StateShape as settingsStateShape, settingsReducer } from './settings';
import { StateShape as fundsSelctorStateShape, fundsSelectorReducer } from './fundsSelectors';
import { StateShape as AdminContentListStateShape, contentListReducer } from './contentList';
import { StateShape as slidedecksStateShape, slidedecksReducer } from './slidedecks';

export interface StateShape {
    templateEditor: TemplateEditorStateShape;
    app: AppStateShape;
    auth: AuthStateShape;
    adminPages: AdminPagesStateShape;
    components: AdminComponentsStateShape;
    publicComponents: AdminPublicComponentsStateShape;
    resources: resourcesStateShape;
    adminUI: adminUIStateShape;
    themes: AdminThemesStateShape;
    query: AdminQueryStateShape;
    users: AdminUsersStateShape;
    lists: listsStateShape;
    media: AdminMediaStateShape;
    envDiff: envDiffStateShape;
    settings: settingsStateShape;
    funds: fundsSelctorStateShape;
    contentList: AdminContentListStateShape;
    slidedecks: slidedecksStateShape;
}

export type ThunkDispatch = redux.ThunkDispatch<StateShape, never, redux.AnyAction>;
export type ThunkResult<T> = redux.ThunkAction<T, StateShape, {}, redux.AnyAction>;

export const reducers = {
    auth: authReducer,
    templateEditor: templateEditorReducer,
    adminPages: AdminPagesReducer,
    app: appReducer,
    components: AdminComponentsReducer,
    publicComponents: AdminPublicComponentsReducer,
    resources: resourcesReducer,
    adminUI: adminUIReducer,
    themes: themesReducer,
    query: queryReducer,
    users: usersReducer,
    lists: listsReducer,
    media: mediaReducer,
    envDiff: envDiffReducer,
    settings: settingsReducer,
    funds: fundsSelectorReducer,
    contentList: contentListReducer,
    slidedecks: slidedecksReducer,
};

export default reducers;
